import React from 'react';
import { Alert } from 'reactstrap';
import { useIntl } from 'react-intl';

import { userHasFeature } from '../../../helpers/Features';

const AdminUsersLimitWarning = () => {
  const intl = useIntl();

  if (userHasFeature('unlimited-users')) {
    return null;
  }

  return (
    <Alert color="warning">
      {intl.formatMessage({ defaultMessage: 'Need to invite more than 10 team members in our Free tier? Contact us through the in-workspace chat.' })}
    </Alert>
  );
};

export default AdminUsersLimitWarning;
